import { codexList } from '../data/codex-list';
import { BOSS_INFO, FAM_INFO } from '../data/codex';
import { TINT } from '../entities/enemy-parts';
import { META, codexStage } from '../platform/storage';
/* ============================================================
   圖鑑左欄：索引（家族摺疊 + 三顆快篩）
   ============================================================

   三段解鎖（使用者 2026-08-02 指定，不要重新詮釋）：
   沒看過＝大問號、看過沒打死＝黑影、打死過＝正常。
   三種狀態的**明度**差距要夠大 —— 這一欄有 68 列，玩家是用掃的不是用讀的。

   B3 加的：家族可摺疊、快篩三顆（全部／小怪／BOSS）。
   **不做多軸篩選** —— 68 筆資料配四軸篩選是過度設計，而且篩選列會吃掉欄高。
   搜尋框做過，使用者 2026-08-03 指示拿掉（見 `LQ` 的說明）。 */

var $ = function (id) { return document.getElementById(id) as any; };

/** 快篩。`mode`：all｜mob｜boss。
    ⚠️ `q`（搜尋字串）**保留但永遠是空的** —— 搜尋框已依使用者 2026-08-03
    指示拿掉。留著欄位與比對邏輯是因為它零成本（空字串一律放行），
    哪天要把搜尋加回來不用重寫過濾與 `visibleList()`。 */
export var LQ = { q: '', mode: 'all' };
/** 摺疊起來的家族（key = fam）。 */
var fold: any = {};
var refresh = function () { };

/** 依家族分組的清單資料。順序照規格 §2b 的 `FAMORDER`（`ALL_TYPES` 已經照排），
    **BOSS 是最後一組**（規格 §5.2：BOSS 不受家族約束是刻意的）。
    `dev` 為真時 Boss 全 28 隻，否則只有排進時刻表的（見 `data/codex-list.ts`）。 */
export function codexGroups(dev?) {
  var list = codexList(dev), out: any[] = [], cur: any = null;
  for (var i = 0; i < list.length; i++) {
    var T = list[i];
    if (!cur || cur.fam !== T.fam) { cur = { fam: T.fam, list: [] }; out.push(cur); }
    cur.list.push(T);
  }
  return out;
}

/** 解析進度：打死過幾種 / 全部幾種。**分母是玩家看得到的那些** ——
    開發模式才存在的那些 Boss 算進分母的話，進度永遠到不了滿。 */
export function codexProgress() {
  var list = codexList(false), n = 0;
  for (var i = 0; i < list.length; i++) if (codexStage(list[i].id) === 2) n++;
  return n + ' / ' + list.length;
}

/** 搜尋只比對「你已經知道的東西」。未解鎖的不該被名字搜出來 ——
    那等於用搜尋框把圖鑑自己鎖著的資訊洩漏出去。
    看過沒打死的還搜得到家族代號，因為**形狀正是你已經看到的東西**。 */
function hit(T, st, q) {
  if (!q) return true;
  if (st === 2) return (T.code + ' ' + (T.zh || '') + ' ' + (T.role || '')).toLowerCase().indexOf(q) >= 0;
  if (st === 1) return String(T.fam).toLowerCase().indexOf(q) >= 0;
  return false;
}

function passMode(T) {
  return LQ.mode === 'all' || (LQ.mode === 'boss' ? !!T.boss : !T.boss);
}

/** 一次算完「誰列得出來」。清單與 ↑↓ 換敵種走同一份，
    否則會出現「畫面上沒有這一列，但按下去跳到它」。 */
export function visibleList(dev) {
  var gs = codexGroups(dev), out: any[] = [], q = LQ.q.trim().toLowerCase();
  for (var g = 0; g < gs.length; g++) {
    for (var i = 0; i < gs[g].list.length; i++) {
      var T = gs[g].list[i];
      if (passMode(T) && hit(T, dev ? 2 : codexStage(T.id), q)) out.push(T);
    }
  }
  return out;
}

function rowHTML(T, st, selId) {
  var name = st === 0 ? '？？？？' : (st === 1 ? '█████' : T.code);
  var col = st === 2 ? (TINT[T.tint] || TINT.red).hex : 0;
  return '<button class="crow s' + st + (T.deep ? ' deep' : '') + (T.boss ? ' bossrow' : '')
    + (T.id === selId ? ' on' : '') + '" data-id="' + T.id + '">'
    + '<i' + (col ? ' style="background:#' + col.toString(16).padStart(6, '0') + ';border-color:transparent"' : '') + '></i>'
    + '<b>' + name + '</b>'
    + '<span>' + (st === 2 ? (T.zh || '') : (st === 1 ? (META.seen[T.id] || 0) + '×' : '')) + '</span>'
    + '</button>';
}

/** 左欄。`dev` 為真時**忽略解鎖**（開發模式要看得到全部）。 */
export function renderList(selId, dev, onPick) {
  var el = $('cRows');
  if (!el) return;
  var gs = codexGroups(dev), h = '', shown = 0;
  var q = LQ.q.trim().toLowerCase(), searching = !!q;
  for (var g = 0; g < gs.length; g++) {
    var fam = gs[g].fam;
    var rows = '', n = 0;
    for (var i = 0; i < gs[g].list.length; i++) {
      var T = gs[g].list[i], st = dev ? 2 : codexStage(T.id);
      if (!passMode(T) || !hit(T, st, q)) continue;
      n++; shown++;
      rows += rowHTML(T, st, selId);
    }
    if (!n) continue;
    /* BOSS 分組：跟八個家族拉開一條線。它們不是第九個家族（規格 §5.2），
       所以標題不給中文、列本身用暖色的左緣 —— 一眼看得出「這一段不一樣」。 */
    var F = fam === 'boss' ? BOSS_INFO : (FAM_INFO[fam] || { zh: fam, sil: '' });
    var off = !searching && !!fold[fam];
    h += '<button class="cfam' + (fam === 'boss' ? ' boss' : '') + (off ? ' off' : '')
      + '" data-fam="' + fam + '"><em>' + (off ? '▸' : '▾') + '</em><b>'
      + String(fam).toUpperCase() + '</b> ' + (fam === 'boss' ? '' : F.zh)
      + '<span>' + n + '</span></button>';
    if (!off) h += rows;
  }
  if (!shown) h = '<div class="cnone">沒有符合的條目</div>';
  el.innerHTML = h;

  var btns = el.querySelectorAll('.crow');
  for (var r = 0; r < btns.length; r++) {
    (function (b) { b.onclick = function () { onPick(b.getAttribute('data-id')); }; })(btns[r]);
  }
  var heads = el.querySelectorAll('.cfam');
  for (var k = 0; k < heads.length; k++) {
    (function (b) {
      b.onclick = function () {
        var f = b.getAttribute('data-fam');
        fold[f] = !fold[f];
        refresh();
      };
    })(heads[k]);
  }
}

/** 快篩只綁一次 —— 它們在靜態 HTML 裡，不隨 `renderList` 重建。 */
export function initCodexList(onRefresh) {
  refresh = onRefresh || refresh;
  var s = $('cSearch');
  if (s) {
    s.value = LQ.q;
    s.oninput = function (e) { LQ.q = e.target.value || ''; refresh(); };
  }
  var q = $('cQuick');
  if (!q) return;
  var bs = q.querySelectorAll('button');
  for (var i = 0; i < bs.length; i++) {
    (function (b) {
      b.onclick = function () {
        LQ.mode = b.getAttribute('data-f') || 'all';
        var all = q.querySelectorAll('button');
        for (var j = 0; j < all.length; j++) all[j].classList.toggle('on', all[j] === b);
        refresh();
      };
    })(bs[i]);
  }
}

/** 離開圖鑑時把篩選收乾淨。下次進來看到的是完整的 68 列 ——
    「上次的搜尋字串還留著」會讓人以為圖鑑掉了一半的資料。 */
export function resetCodexFilters() {
  LQ.q = ''; LQ.mode = 'all'; fold = {};
  var s = $('cSearch'); if (s) s.value = '';
  var q = $('cQuick');
  if (!q) return;
  var bs = q.querySelectorAll('button');
  for (var i = 0; i < bs.length; i++) bs[i].classList.toggle('on', bs[i].getAttribute('data-f') === 'all');
}
